export default __webpack_public_path__ + "static/media/pineapple.fedeca6c.jpg";